// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__kZWmW","green":"Tag_green__FTYxR","red":"Tag_red__xfOnA"};